module.exports = __webpack_public_path__ + "img/mir.22c1a038a67f.svg";